export default {
  companyProgramStatusName: (state) => (status) => {
    switch (Number(status)) {
      case state.programStatuses.inactive:
        return 'inactive';
      case state.programStatuses.active:
        return 'active';
      case state.programStatuses.deactivated:
        return 'deactivated';
      case state.programStatuses.ended:
        return 'archived';
      default:
        return '';
    }
  },
};
